export const Currencies = {
  GBP: "GBP",
  EUR: "EUR",
  USD: "USD",
  AED: "AED",
  AFN: "AFN",
  ALL: "ALL",
  AMD: "AMD",
  ANG: "ANG",
  AOA: "AOA",
  ARS: "ARS",
  AUD: "AUD",
  AWG: "AWG",
  AZN: "AZN",
  BAM: "BAM",
  BBD: "BBD",
  BDT: "BDT",
  BGN: "BGN",
  BMD: "BMD",
  BND: "BND",
  BOB: "BOB",
  BRL: "BRL",
  BSD: "BSD",
  BWP: "BWP",
  BYN: "BYN",
  BZD: "BZD",
  CAD: "CAD",
  CDF: "CDF",
  CHF: "CHF",
  COP: "COP",
  CRC: "CRC",
  CVE: "CVE",
  CZK: "CZK",
  DKK: "DKK",
  DOP: "DOP",
  DZD: "DZD",
  EGP: "EGP",
  ETB: "ETB",
  FJD: "FJD",
  FKP: "FKP",
  GEL: "GEL",
  GIP: "GIP",
  GMD: "GMD",
  GTQ: "GTQ",
  GYD: "GYD",
  HKD: "HKD",
  HNL: "HNL",
  HRK: "HRK",
  HTG: "HTG",
  HUF: "HUF",
  IDR: "IDR",
  ILS: "ILS",
  INR: "INR",
  ISK: "ISK",
  JMD: "JMD",
  KES: "KES",
  KGS: "KGS",
  KHR: "KHR",
  KYD: "KYD",
  KZT: "KZT",
  LAK: "LAK",
  LBP: "LBP",
  LKR: "LKR",
  LRD: "LRD",
  LSL: "LSL",
  MAD: "MAD",
  MDL: "MDL",
  MKD: "MKD",
  MMK: "MMK",
  MNT: "MNT",
  MOP: "MOP",
  MRO: "MRO",
  MUR: "MUR",
  MVR: "MVR",
  MWK: "MWK",
  MXN: "MXN",
  MYR: "MYR",
  MZN: "MZN",
  NAD: "NAD",
  NGN: "NGN",
  NIO: "NIO",
  NOK: "NOK",
  NPR: "NPR",
  NZD: "NZD",
  PAB: "PAB",
  PEN: "PEN",
  PGK: "PGK",
  PHP: "PHP",
  PKR: "PKR",
  PLN: "PLN",
  QAR: "QAR",
  RON: "RON",
  RSD: "RSD",
  SAR: "SAR",
  SBD: "SBD",
  SCR: "SCR",
  SEK: "SEK",
  SGD: "SGD",
  SHP: "SHP",
  SLL: "SLL",
  SOS: "SOS",
  SRD: "SRD",
  STD: "STD",
  SZL: "SZL",
  THB: "THB",
  TJS: "TJS",
  TOP: "TOP",
  TRY: "TRY",
  TTD: "TTD",
  TWD: "TWD",
  TZS: "TZS",
  UAH: "UAH",
  UYU: "UYU",
  UZS: "UZS",
  WST: "WST",
  XCD: "XCD",
  YER: "YER",
  ZAR: "ZAR",
  ZMW: "ZMW",
  CNY: "CNY",
};
